import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-login',
  animations: [
    trigger(
      'pageFade', [
        transition(':enter', [
          style({opacity: 0}),
          animate('300ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('300ms', style({opacity: 0}))
        ])
      ]
    )
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  // @Input() on: boolean;
  // @Input() close: Function;
  isOpen = false;
  usernameModel = '';
  passwordModel = '';
  message = '';
  loading: any = false;
  openMenuCb;

  constructor(private loginService: LoginService) {}

  openLogin(openMenuCb) {
    this.isOpen = true;
    this.openMenuCb = openMenuCb;
    this.message = '';
    this.loading = false;
  }
  closeLogin() {
    this.isOpen = false;
  }
  async sendLoginInfo(formData) {
    this.loading = true;
    const { username, password } = formData.value;
    try {
      const user = await this.loginService.logIn(username, password);
      this.message = 'Successful!';
      this.loading = 'Success';
      this.closeLogin();
      this.openMenuCb(user);
      this.loading = false;
    } catch (err) {
      console.error(err);
      this.passwordModel = '';
      this.message = 'Incorrect credentials';
      this.loading = false;
    }
  }

  ngOnInit() {
  }
}
